import React, { useState } from 'react';
const faqs: {
  question: string;
  answer: string;
}[] = [{
  question: '¿Cómo recibo el Megapack después de comprar?',
  answer: 'Todo es 100% digital en formato PDF. Recibís un email con el acceso inmediato dentro de los 5 minutos posteriores a la compra. Sin esperas, sin envíos.'
}, {
  question: '¿Necesito fuerza de voluntad para que funcione?',
  answer: 'No. El sistema está diseñado exactamente para eso: para que el foco sea el camino de menor resistencia. No necesitás motivación ni disciplina extrema para arrancar. Solo seguir el protocolo.'
}, {
  question: '¿Sirve si ya probé mil métodos y nunca funcionaron?',
  answer: 'Sí, especialmente para vos. La mayoría de los métodos fallan porque atacan la disciplina y no la biología. El Megapack ataca directamente la dopamina secuestrada, que es la causa real del problema.'
}, {
  question: '¿Los 4 bonos están en las dos ofertas?',
  answer: 'Sí. Los 4 bonos exclusivos están incluidos en ambas opciones sin costo extra. La diferencia del plan PRO es que agrega el Sistema Ejecutor PRO™ con el tablero de 90 días y los protocolos avanzados.'
}, {
  question: '¿Sirve si trabajo desde casa y me cuesta separar el ocio del trabajo?',
  answer: 'Es exactamente para eso. El Tomo 3 (Ingeniería de Entorno) está diseñado para crear una separación psicológica y física entre el modo "ocio" y el modo "ejecución", incluso en el mismo espacio.'
}, {
  question: '¿Cuánto tiempo por día necesito para aplicarlo?',
  answer: 'El Sistema de 3 Bloques funciona con bloques de 90 minutos. Podés arrancar con un solo bloque por día. En 90 minutos bien ejecutados vas a hacer más que en un día entero de trabajo disperso.'
}, {
  question: '¿Qué pasa si recaigo y vuelvo al scroll infinito?',
  answer: 'Para eso existe el Tomo 5 — Protocolo S.O.S. Anti-Recaída. Es un plan de rescate de 3 pasos para volver al sistema sin drama ni culpa en menos de 24 horas.'
}, {
  question: '¿Qué diferencia tiene este sistema con otros cursos de productividad?',
  answer: 'No es un curso de "gestión del tiempo". Es una intervención biológica. Atacamos la dopamina, el entorno y la identidad al mismo tiempo. La mayoría de los métodos solo trabajan uno de los tres.'
}, {
  question: '¿Por qué elegir el Sistema Ejecutor PRO y no el estándar?',
  answer: 'El PRO agrega el tablero de control a 90 días, los checklists avanzados y el mapa de hábitos. Si querés ver tu progreso en tiempo real y no solo "sentir" que mejorás, el PRO es la diferencia entre hacerlo y comprobarlo.'
}, {
  question: '¿Tiene garantía real?',
  answer: 'Sí. Garantía Ejecutor™ de 30 días sin preguntas. Si en 30 días no recuperaste el control de tu atención, te devolvemos el 100% de tu dinero. Sin formularios. Sin drama.'
}];
export function FAQ() {
  const [openIndex, setOpenIndex] = useState<number | null>(null);
  return <section className="w-full px-4 py-10 text-base leading-6" style={{
    backgroundColor: '#0d0d0d',
    fontFamily: '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, sans-serif'
  }} data-id="element-140">
      <div className="mx-auto max-w-3xl" data-id="element-141">
        <h2 className="text-3xl font-black text-center leading-10 text-white m-0 mb-8" data-id="element-142">
          ❓ PREGUNTAS FRECUENTES
        </h2>

        <div className="space-y-2" data-id="element-143">
          {faqs.map((faq, i) => <div key={i} className="transition-colors border border-yellow-400/20 rounded-lg shadow-sm" style={{
          backgroundColor: openIndex === i ? 'rgba(234, 179, 8, 0.05)' : 'rgba(255,255,255,0.02)'
        }} data-id="element-144">
              <button onClick={() => setOpenIndex(openIndex === i ? null : i)} aria-expanded={openIndex === i} className="flex w-full items-center justify-between gap-3 text-left bg-transparent cursor-pointer border-0 px-4 py-3 m-0" style={{
            fontFamily: 'inherit'
          }} data-id="element-145">
                <span className="text-sm font-bold text-white" data-id="element-146">
                  ❓ {i + 1} — {faq.question}
                </span>
                <span className={`shrink-0 text-lg text-yellow-400 transition-transform duration-200 ${openIndex === i ? 'rotate-45' : ''}`} data-id="element-147">
                  +
                </span>
              </button>

              {/* Answer */}
              {openIndex === i && <div className="px-4 pb-4" data-id="element-148">
                  <p className="text-sm text-gray-300 m-0 leading-relaxed" data-id="element-149">
                    {faq.answer}
                  </p>
                </div>}
            </div>)}
        </div>
      </div>
    </section>;
}